import { css } from '@emotion/core'

export const styles = {
  container: css`
    display: flex;
    flex-direction: column;

    width: 100%;
    padding: 8px;

    box-shadow: 0 0 1px 0 rgb(230, 230, 230);
    background: rgb(255, 255, 255);
    opacity: 1;

    cursor: default;
  `,

  seen: css`
    background: rgba(58, 137, 196, 0.02);
    opacity: 0.9;
  `,

  icon: css`
    cursor: pointer;
    transition: 300ms;

    &:hover {
      transform: scale(1.1);
      transition: 100ms;
    }
  `,

  section: css`
    position: relative;
    flex: 1;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    padding: 1px;
  `,

  title: css`
    flex: 1;

    display: flex;
    align-items: center;

    font-weight: 600;
    font-size: 14px;

    padding: 3px;
  `,

  message: css`
    flex: 1;

    display: flex;
    align-items: center;

    font-weight: 400;
    font-size: 14px;

    padding: 3px;
  `,
}
